import { EventsService } from "@app/services/events.service"
import { PermsService } from "./../services/perms.service"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { ApiService } from "@app/services/api.service"
import { environment } from "@env/environment"
import { LangService } from "@app/services/lang.service"
import { Component, OnInit, ViewChild } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { MenuService } from "@app/services/menu.service"

@Component({
	selector: "app-menu",
	templateUrl: "./menu.component.html",
})
export class MenuComponent implements OnInit {
	environment = environment
	cliniqData: any = null
	userMenuIsOpen: boolean = false
	notiTotal: number = null
	@ViewChild("searchFuzzy") searchFuzzy: GenAutocompleteComponent
	isOwner: boolean = false
	showSearchByPhone: string = "no"
	old_debts_report: boolean = false
	enable_israel_invoice: boolean = false
	curMenuItem: string = ""
	isContactwaySearchOpen: boolean = false
	isPatientSearchOpen: boolean = false

	constructor(
		public modalService: ModalService,
		public lang: LangService,
		private router: Router,
		public route: ActivatedRoute,
		private apiService: ApiService,
		public store: StoreService,
		public permsService: PermsService,
		public eventsService: EventsService,
		public menuService: MenuService
	) {}

	async ngOnInit() {
		this.cliniqData = this.store.getCliniqDataOrExit()
		this.isOwner = this.cliniqData.has_users
		this.showSearchByPhone = this.cliniqData.show_search_by_phone
		this.enable_israel_invoice =
			this.cliniqData.enable_israel_invoice == "yes" ? true : false

		this.eventsService.docClickSubject.subscribe((val: any) => {
			if (val?.src !== "userMenu") {
				this.userMenuIsOpen = false
			}
			if (val?.src !== "contactwaySearchIcon") {
				this.isContactwaySearchOpen = false
			}
			if (
				val?.src !== "patientSearchIcon" &&
				!(val?.src instanceof GenAutocompleteComponent)
			) {
				this.isPatientSearchOpen = false
			}
		})

		this.router.events.subscribe((event) => {
			if (this.router?.url) {
				const parts = this.router.url.split("/")
				this.curMenuItem = parts[1]
				if (this.curMenuItem == "home-admin") {
					this.curMenuItem = "home"
				}
			}
		})

		this.route.queryParams.subscribe((params) => {
			if (params?.taskId) {
				// this.modalService.openMulti("tasks",{taskId:params.taskId})
				this.modalService.openMulti("task", { taskId: params.taskId })
			}
		})
		await this.store.timeout(2000)
		this.store.get_task_notifications_total()
	}
	handlePatientSearchIconClick(ev: any) {
		this.isPatientSearchOpen = !this.isPatientSearchOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "patientSearchIcon" })
	}
	handleContactwaySearchIconClick(ev: any) {
		this.isContactwaySearchOpen = !this.isContactwaySearchOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "contactwaySearchIcon" })
	}

	userMenuOpen(ev: any) {
		this.userMenuIsOpen = !this.userMenuIsOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "userMenu" })
	}

	logout() {
		this.apiService.doLogout()
	}
	removeForPerms(arrItems: any[]) {
		for (let item of arrItems) {
			if (item.perms) {
				if (this.permsService.hasMissingPerm(item.perms)) {
					item.hidden = true
				}
			}
			if (item.children) {
				this.removeForPerms(item.children)
			}
		}
	}

	async fuzzyClick(obj: any = null) {
		if (obj && obj.id) {
			this.router.navigateByUrl("/" + obj.typeClassName + "/" + obj.id)
			await this.store.timeout()
			this.searchFuzzy?.emptySearchStr()
		}
	}

	clickNoti() {
		// this.modalService.openMulti("tasks");
		this.modalService.openMulti("task")
	}

	menuItemClick(item: any) {
		if (!item.link && !item.modal && !item.isReportsModal) {
			return
		}
		this.modalService.closeLatestModal()
		if (item.isReportsModal) {
			this.modalService.openMulti("reports", { report_name: item.report_name })
		} else if (item.modal) {
			this.modalService.openMulti(item.modal)
		} else {
			if (item.link === "calendar") {
				const to = `/calendar/${this.store.lastCalView || "week"}/today`
				this.router.navigateByUrl(to)
			} else {
				this.router.navigateByUrl("/" + item.link)
			}
		}
		this.menuService.menu.forEach((it) => {
			if (it.isOpen) {
				it.isOpen = false
			}
			if (it.children) {
				it.children.forEach((it2) => {
					if (it2.isOpen) {
						it2.isOpen = false
					}
					if (it2.children) {
						it2.children.forEach((it3) => {
							if (it3.isOpen) {
								it3.isOpen = false
							}
						})
					}
				})
			}
		})
	}

	openAffiliateLink() {
		const aff_code = this.store.getCliniqDataOrExit()?.aff_code
		const link = location.origin + "/regi/regi?affiliate_user_id=" + aff_code
		const langText = "affiliate_link"
		this.modalService.openMulti("copy-link", { link, langText })
	}
	openInvitePartner() {
		this.modalService.openMulti("invite-partner")
	}
	openCreateTakbullAccount() {
		this.modalService.openMulti("create-takbull-account")
	}
	openCreateGrowAccount() {
		this.modalService.openMulti("create-grow-account")
	}
	openItaGetAuth() {
		this.modalService.openMulti("ita-get-auth")
	}
	openChangePassword() {
		this.modalService.openMulti("change-password")
	}
	openPatientForm() {
		const newName = ""
		// const newName=((this.personFuzzyInput?.searchStr || ""));
		const newPatient: any = this.modalService.openMulti("types-create", {
			newName,
		})

		// if(newPatient){
		//   this.choosePatientOrContact(newPatient);
		//   if(newPatient?.assoc){
		//     // this.emptyAssoc();
		//     const objs=this.store.getSiteDataTable("sub_users").filter(it=>newPatient.assoc.includes(it.id));
		//     // objs.forEach(it=>this.addSubUser({...it,typeClassName:"sub_users"}));
		//   }
		// }
	}
}
